export type PlayerColor =
  | 'orange'
  | 'lightblue'
  | 'pink'
  | 'mint'
  | 'purple'
  | 'gray'
  | 'white'
  | 'magenta'
  | 'darkgreen'
  | 'darkblue'
  | 'yellow'
  | 'black';

// Global color mapping with specific hex codes to match the image
export const COLOR_MAP: Record<PlayerColor, string> = {
  orange: 'bg-[#FF6B00] border-[#FF6B00]',
  lightblue: 'bg-[#60A5FA] border-[#60A5FA]',
  pink: 'bg-[#EC4899] border-[#EC4899]',
  mint: 'bg-[#6EE7B7] border-[#6EE7B7]',
  purple: 'bg-[#8B5CF6] border-[#8B5CF6]',
  gray: 'bg-[#9CA3AF] border-[#9CA3AF]',
  white: 'bg-white border-white',
  magenta: 'bg-[#D946EF] border-[#D946EF]',
  darkgreen: 'bg-[#166534] border-[#166534]',
  darkblue: 'bg-[#1E40AF] border-[#1E40AF]',
  yellow: 'bg-[#FBBF24] border-[#FBBF24]',
  black: 'bg-black border-[#374151]',
};

export const COLOR_OPTIONS: { value: PlayerColor; className: string; name: string }[] = [
  { value: 'orange', className: 'bg-[#FF6B00]', name: 'Orange' },
  { value: 'lightblue', className: 'bg-[#60A5FA]', name: 'Light Blue' },
  { value: 'pink', className: 'bg-[#EC4899]', name: 'Pink' },
  { value: 'mint', className: 'bg-[#6EE7B7]', name: 'Mint' },
  { value: 'purple', className: 'bg-[#8B5CF6]', name: 'Purple' },
  { value: 'gray', className: 'bg-[#9CA3AF]', name: 'Gray' },
  { value: 'white', className: 'bg-white', name: 'White' },
  { value: 'magenta', className: 'bg-[#D946EF]', name: 'Magenta' },
  { value: 'darkgreen', className: 'bg-[#166534]', name: 'Dark Green' },
  { value: 'darkblue', className: 'bg-[#1E40AF]', name: 'Dark Blue' },
  { value: 'yellow', className: 'bg-[#FBBF24]', name: 'Yellow' },
  { value: 'black', className: 'bg-black border border-[#374151]', name: 'Black' },
];

export const getPlayerColor = (color: PlayerColor) => {
  return COLOR_OPTIONS.find((c) => c.value === color)?.className || 'bg-border';
};

export const getPlayerTextColor = (color: PlayerColor) => {
  return color === 'white' || color === 'yellow' ? 'text-black' : 'text-white';
};

export const getPlayerColorClasses = (color: PlayerColor) => {
  return COLOR_MAP[color] || 'bg-border border-border';
};

const HEX_MAP: Record<PlayerColor, string> = {
  orange: '#FF6B00',
  lightblue: '#60A5FA',
  pink: '#EC4899',
  mint: '#6EE7B7',
  purple: '#8B5CF6',
  gray: '#9CA3AF',
  white: '#ffffff',
  magenta: '#D946EF',
  darkgreen: '#166534',
  darkblue: '#1E40AF',
  yellow: '#FBBF24',
  black: '#000000',
};

export const getPlayerColorHex = (color: PlayerColor): string => {
  return HEX_MAP[color] || '#9CA3AF';
};
